const faqs = [
  {
    q: '六六影院的电影都是免费观看的吗？',
    a: '是的，六六影院所有高清电影资源均免费在线观看，无需注册登录即可直接播放。我们持续更新片库，确保你能第一时间观看到最新上映的大片和经典电影。',
  },
  {
    q: '播放电影需要安装插件或下载播放器吗？',
    a: '完全不需要。六六影院采用先进的在线流媒体技术，只需浏览器即可直接观看，无需安装任何插件或播放器。支持电脑、平板和手机多端观看。',
  },
  {
    q: '电影画质怎么样？有高清版本吗？',
    a: '六六影院提供1080P超清画质的观影体验，大部分影片均有高清版本可选。我们采用智能CDN加速技术，确保高清播放流畅不缓冲，让你享受影院级观影感受。',
  },
  {
    q: '每天更新多少部新电影？',
    a: '六六影院每日稳定更新30部以上新片，涵盖动作、科幻、喜剧、悬疑、爱情、动画等全类型。我们紧跟院线和流媒体上线节奏，让你不错过任何一部热门电影。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于六六影院，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between px-6 py-4 md:px-8 md:py-5 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {item.q}
                </h3>
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-open:bg-primary-500 group-open:text-background-50 transition-all duration-200">
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                </div>
              </summary>
              <div className="px-6 pb-5 md:px-8 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}